import { Checkroom } from "@mui/icons-material";
import React, { useEffect, useState } from "react";

interface PlaceholderImageProps {
  loading?: boolean;
  imageUrl?: string | null;
  imageLoading?: "eager" | "lazy";
  alt?: string;
  className?: string;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  loading = false,
  imageUrl,
  imageLoading,
  alt = "",
  className = "",
}) => {
  const [showImage, setShowImage] = useState(Boolean(imageUrl));

  useEffect(() => {
    setShowImage(Boolean(imageUrl));
  }, [imageUrl]);

  return (
    <div
      className={`
        bg-slate-200 flex items-center justify-center text-slate-500 overflow-hidden
        ${loading ? "animate-pulse" : ""}
        ${className}
      `}
    >
      {showImage ? (
        <img
          src={imageUrl ?? undefined}
          alt={alt}
          className="w-full h-full object-cover scale-125"
          loading={imageLoading}
          onError={() => setShowImage(false)}
        />
      ) : (
        <Checkroom aria-hidden="true" fontSize="medium" />
      )}
    </div>
  );
};

export default PlaceholderImage;
